
























































import { Component, Vue, Prop } from "vue-property-decorator";
import { CreateComprehensiveExport } from "@/request/export";

@Component({})
export default class ComprehensiveExportDialog extends Vue {
  @Prop()
  private ifShow: any;
  private projectOptions: string[] = [
    "舌诊",
    "面诊",
    "脉诊",
    "目诊",
    "掌诊",
    "体质辨识",
  ];
  private selectedItems: string[] = [...this.projectOptions];
  private exportName: string = "";
  private time: string[] = [];
  private pickerOptions: any = {
    disabledDate(time: Date) {
      return time.getTime() > Date.now();
    },
  };
  private get visible() {
    return this.ifShow;
  }
  private set visible(val) {
    this.$emit("update:ifShow", val);
  }
  private cancel() {
    this.visible = false;
  }
  /**
   * @description 创建综合导出任务
   */
  private confirm() {
    if (!this.selectedItems.length) {
      this.$message.warning("请选择导出项目");
      return;
    }
    if (!this.time || this.time.length !== 2) {
      this.$message.warning("请选择采集时间");
      return;
    }
    const params: any = {
      导出项目: this.selectedItems,
      开始时间: this.time[0],
      结束时间: this.time[1],
    };
    if (this.exportName) {
      params["名称"] = this.exportName;
    }
    const loading = this.$loading({
      lock: true,
      text: "提交中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    CreateComprehensiveExport(this, params, loading)
      .then(() => {
        loading.close();
        this.$message.success("已提交综合导出任务");
        this.$emit("confirm");
        this.visible = false;
      })
      .catch(() => {
        loading.close();
      });
  }
}
